module.exports = "/build/web/svg/search.d82fd50718f7a3f203160e6039074a95.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/search.svg
// module id = 100
// module chunks = 24